import { render } from "./TaskAnalysis.vue?vue&type=template&id=788c38f9"
import script from "./TaskAnalysis.vue?vue&type=script&lang=js"
export * from "./TaskAnalysis.vue?vue&type=script&lang=js"
script.render = render

export default script